module.exports = __webpack_public_path__ + "static/img/cpap-icon.cb91ff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cpap-icon.png
// module id = TM57
// module chunks = 1